var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VcLayout',{staticClass:"VcImage",attrs:{"justify-content-center":"","data-qa":_vm.dataQa}},[(_vm.image && typeof _vm.image === 'string')?_c('img',{staticClass:"image",attrs:{"src":_vm.image}}):_c(_vm.image,{tag:"component",staticClass:"image"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }